import {JSX} from "wfr/commons/jsx"
import {EExtType, EProductType, JDownloadProductSource} from "../../commons/api";
import {JMessage, MessageBox} from "../../commons/messages";
import {depsProducts, urltree} from "./product";
import {Dict} from "wfr/commons/common"
import {lang} from "../../commons/language-selector";
import {ETileTitle, ProductTile} from "../product-tile";
import {sort} from "../commons";

export {DownloadMessageBox}

class DownloadMessageBox extends MessageBox{
	protected deps:{[key in EProductType]:Dict<JDownloadProductSource[]>}

	constructor(message:JMessage) {
		super(message, lang)
		this.deps = {} as {[key in EProductType|EExtType]:Dict<JDownloadProductSource[]>}
		for(let key in depsProducts){
			depsProducts[key].sort(sort)
			//On garde la première version pour indiquer le x.x+ dans la liste des dépendances et la dernière pour le lien
			const productType = depsProducts[key][0].productType

			if(!(productType in this.deps)) this.deps[productType]={}
			this.deps[productType][key] = [depsProducts[key][0], depsProducts[key][depsProducts[key].length-1]]
		}
	}

	protected publishMessage():boolean{
		//On ne publie pas de message de dépendances vides...
		if(this.message.level == "intdep" && Object.keys(this.deps).length == 0) return false
		if(this.message.level == "intdep-server" && !this.deps[EProductType.server]) return false
		if(this.message.level == "intdep-application" && !this.deps[EProductType.application]) return false
		if(this.message.level == "intdep-extension" && !this.deps[EProductType.extension]) return false
		if(this.message.level == "intdep-devtool" && !this.deps[EProductType.devtool]) return false
		return true;
	}

	protected addMessageContent():Element{
		if (this.message.level.startsWith("intdep")) return <ul>
			{this.deps[EProductType.server] && (this.message.level == "intdep" || this.message.level == "intdep-server") ?
				Object.keys(this.deps[EProductType.server]).sort().map(productRef=>{return this.buildLi(EProductType.server, productRef)}):null
			}
			{this.deps[EProductType.application] && (this.message.level == "intdep" || this.message.level == "intdep-application") ?
				Object.keys(this.deps[EProductType.application]).sort().map(productRef=>{return this.buildLi(EProductType.application, productRef)}):null
			}
			{this.deps[EProductType.devtool] && (this.message.level == "intdep" || this.message.level == "intdep-devtool") ?
				Object.keys(this.deps[EProductType.devtool]).sort().map(productRef=>{return this.buildLi(EProductType.devtool, productRef)}):null
			}
			{this.deps[EProductType.extension] && (this.message.level == "intdep" || this.message.level == "intdep-extension") ?
				Object.keys(this.deps[EProductType.extension]).sort().map(productRef=>{return this.buildLi(EProductType.extension, productRef)}):null
			}
		</ul>;
		else return null;
	}

	protected buildLi(key:EProductType, productRef:string){
		const dep = this.deps[key as EProductType][productRef]
		const first = dep[0]
		const last = dep[1]
		return <li class={key}>{new ProductTile(last, urltree, {title:ETileTitle.dep, fromMinorVersion:first.minorVersion, addClassName:"intdep"})}</li>
	}
}

customElements.define('download-message-box', DownloadMessageBox)

